module.exports = __webpack_public_path__ + "static/media/ymer.327e09af.jpg";